export class Screen {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly path: string,
  ) {}
}

export class RoleEnum {
  static readonly MAPA: Screen = new Screen(10, 'Mapa', '/map');
  static readonly TEMPO_REAL: Screen = new Screen(30, 'Tempo Real', '/real-time');
  static readonly ALERTS: Screen = new Screen(20, 'Alerts', '/alert');
  static readonly HISTORY: Screen = new Screen(21, 'History', '/alert-history');
  static readonly LICENSE_PLATES: Screen = new Screen(22, 'License Plates', '/plates');
  static readonly PASSAGEM: Screen = new Screen(67, 'Passagem', '/events');
  static readonly PESAGEM: Screen = new Screen(66, 'Pesagem', '/weighing');
  static readonly BI: Screen = new Screen(24, 'B.I.', '/estatisticas');
  static readonly RELATORIOS: Screen = new Screen(25, 'Relatórios', '/reports');
  static readonly INFRACAO: Screen = new Screen(62, 'Infração', '/violation');
  static readonly FLOW_DATA: Screen = new Screen(68, 'Flow Data', '/flow-data');
  static readonly CONFERENCIA: Screen = new Screen(73, 'Conferência', '/flow-validator');


  static values(): Screen[] {
    return [
      RoleEnum.MAPA,
      RoleEnum.TEMPO_REAL,
      RoleEnum.ALERTS,
      RoleEnum.HISTORY,
      RoleEnum.LICENSE_PLATES,
      RoleEnum.PASSAGEM,
      RoleEnum.PESAGEM,
      RoleEnum.BI,
      RoleEnum.INFRACAO,
      RoleEnum.RELATORIOS,
      RoleEnum.FLOW_DATA,
      RoleEnum.CONFERENCIA
    ];
  }
}


